import { Directive, AfterViewInit, Input, OnDestroy} from "@angular/core";
import { ElementRef } from "@angular/core";
@Directive({
    selector: '[initTooltip]',
    standalone: true,
})
export class InitTooltipDirective implements AfterViewInit, OnDestroy {
    @Input() tooltipOptions: any; // Optional: pass tooltip options

    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        window['$'](this.el.nativeElement).tooltip(this.tooltipOptions);
    }

    ngOnDestroy(): void {
        const tooltipElement = window['$'](this.el.nativeElement);
        if (tooltipElement.data('bs.tooltip')) {
        tooltipElement.tooltip('dispose');
        }
    }
}